/* eslint-disable @typescript-eslint/no-explicit-any */
import { DynamicFormProps } from '@/shared/components/DynamicForm/DynamicForm'

import { useTranslation } from 'react-i18next'

export const useTablesFormConfig = (defaultValues?: any) => {
  const { t } = useTranslation()

  const formConfig = {
    id: 'tables-form',
    defaultValues,
    fields: [
      {
        name: 'title',
        label: t('TABLES_MODAL.DESCRIPTION_TEXT'),
        type: 'label'
      },
      {
        name: 'numberOfTables',
        label: t('TABLES_MODAL.QUANTITY_LABEL'),
        placeholder: t('TABLES_MODAL.QUANTITY_PLACEHOLDER'),
        type: 'number',
        focused: true,
        required: true
      }
    ]
  }
  return formConfig as DynamicFormProps
}
